import { PathStreams } from '../services/path-streams';
import { ScopeStreams } from '@shared/app/scripts/services/scope-streams';

import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';

/**
 */
// TODO document
// TODO cover with tests
angular
  .module('coreModule')
  .directive(
    'swLink',
    (pathStreams: PathStreams, scopeStreams: ScopeStreams) => ({
      restrict: 'A',

      priority: 10,

      link: function (scope, element, attrs) {
        const hrefSubject = new Subject<string>();

        attrs.$observe('href', (value: string) => {
          hrefSubject.next(value);
        });

        // Note! this will work as expected only
        const path$ = hrefSubject.asObservable().pipe(
          map((value: string) => {
            return value.match('^#([^?]*)')[1];
          }),
        );

        pathStreams
          .isSameAs(path$)
          .pipe(takeUntil(scopeStreams.isDestroyed(scope)))
          .subscribe((pathMatches) => {
            if (pathMatches) {
              element.addClass('sw-link--active');
            } else {
              element.removeClass('sw-link--active');
            }
          });
      },
    }),
  );
